import { AuthProvider } from "./auth.tsx";
import { ConvexProvider } from "./convex.tsx";
import { CookieConsentProvider } from "./cookie-consent.tsx";
import { QueryClientProvider } from "./query-client.tsx";
import { SeasonalThemeProvider } from "./seasonal-theme.tsx";
import { ThemeProvider } from "./theme.tsx";
import { Toaster } from "../ui/sonner.tsx";
import { TooltipProvider } from "../ui/tooltip.tsx";
import { CmsTranslationsProvider } from "./cms-translations.tsx";
import { ServiceCommerceProvider } from "./service-commerce.tsx";

export function DefaultProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ConvexProvider>
        <QueryClientProvider>
          <TooltipProvider>
            <ThemeProvider>
              <CmsTranslationsProvider>
                <SeasonalThemeProvider>
                  <CookieConsentProvider>
                    <ServiceCommerceProvider>
                      <Toaster />
                      {children}
                    </ServiceCommerceProvider>
                  </CookieConsentProvider>
                </SeasonalThemeProvider>
              </CmsTranslationsProvider>
            </ThemeProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </ConvexProvider>
    </AuthProvider>
  );
}
